import React from "react";
import { Button, Result, Spin } from "antd";

/**
 * Apresentação da guarda Breakage (sem Redux/hook) — testável isoladamente.
 */
export const BreakageAccessGate = ({
  loading,
  enabled,
  unavailable,
  unauthorized,
  forbidden,
  scopeMismatch,
  error,
  onReload,
  onGoHome,
  children,
}) => {
  if (loading) {
    return (
      <div style={{ padding: 48, textAlign: "center" }} data-testid="breakage-access-loading">
        <Spin />
      </div>
    );
  }

  if (unauthorized) {
    return (
      <Result
        status="error"
        title="Sessão inválida para o Breakage"
        subTitle={
          error ||
          "Não foi possível autenticar a consulta de entitlement (HTTP 401). Faça login novamente."
        }
        extra={
          <Button type="primary" onClick={onGoHome}>
            Voltar ao início
          </Button>
        }
      />
    );
  }

  if (scopeMismatch) {
    return (
      <Result
        status="warning"
        title="Escopo Breakage incompatível com a sessão"
        subTitle={
          error ||
          "O entitlement retornado pelo servidor não corresponde à empresa selecionada. Faça login novamente ou troque de empresa."
        }
        extra={
          <>
            <Button type="primary" onClick={onReload} style={{ marginRight: 8 }}>
              Tentar novamente
            </Button>
            <Button onClick={onGoHome}>Voltar ao início</Button>
          </>
        }
      />
    );
  }

  if (forbidden) {
    return (
      <Result
        status="403"
        title="Acesso ao Breakage não permitido"
        subTitle={
          error ||
          "Sua identidade não possui permissão ou Owner único para consultar o entitlement desta empresa. Isso não significa necessariamente que o Breakage não foi contratado."
        }
        extra={
          <>
            <Button type="primary" onClick={onReload} style={{ marginRight: 8 }}>
              Tentar novamente
            </Button>
            <Button onClick={onGoHome}>Voltar ao início</Button>
          </>
        }
      />
    );
  }

  if (unavailable) {
    return (
      <Result
        status="warning"
        title="Breakage temporariamente indisponível"
        subTitle={
          error ||
          "Não foi possível verificar o entitlement. Confirme a URL da API Breakage / BFF e tente novamente."
        }
        extra={
          <>
            <Button type="primary" onClick={onReload} style={{ marginRight: 8 }}>
              Tentar novamente
            </Button>
            <Button onClick={onGoHome}>Voltar ao início</Button>
          </>
        }
      />
    );
  }

  if (!enabled) {
    return (
      <Result
        status="403"
        title="Breakage não contratado"
        subTitle="Sua empresa ainda não possui o serviço Breakage habilitado (entitlement desabilitado). O menu permanece desabilitado até a contratação."
        extra={
          <Button type="primary" onClick={onGoHome}>
            Voltar ao início
          </Button>
        }
      />
    );
  }

  return children;
};
